export default {
    baca() {
        var url = "content/proses/baca";
        return url;
    },
}


// WEBPACK FOOTER //
// ./src/globalFunc/InterfaceBelog.js